import React, { useEffect, useState } from 'react';
import { Space, Table, Tag } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import styled from 'styled-components';
import useTable from '@/hooks/useTable';
import { getTopicPartitionChartData, getTopicPartitionList } from '@/services/kopTopicService';
import { renderNum } from '@/utils/common';
import SvgIcon from '@/components/SvgIcon';
import BoardModal from '@/components/Cluster/BoardModal';
import ModalHeader from '@/components/Header/Modal';

export default function Partition({ commonProps }) {
  const [visible, setVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState({});

  const columns = [
    {
      title: 'Partition ID',
      colKey: 'partition',
      width: 120,
      fixed: 'left',
    },
    {
      title: 'StartOffset',
      colKey: 'startOffset',
      width: 120,
    },
    {
      title: 'EndOffset',
      colKey: 'endOffset',
      width: 120,
    },
    {
      title: 'MsgNum',
      colKey: 'messageNum',
      width: 120,
      cell: renderNum,
    },
    {
      title: 'Leader Broker',
      colKey: 'leaderBrokerId',
      width: 180,
      cell: ({ row }) => <Tag theme='default'>{row.leaderBrokerId}</Tag>,
    },
    {
      title: 'AR',
      colKey: 'arNodes',
      cell: ({ row }) => (
        <Space size={4} breakLine>
          {row.arNodes?.split(',').map((item, index) => (
            <Tag theme='default' key={index}>
              {item}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      title: 'ISR',
      colKey: 'isrNodes',
      cell: ({ row }) => (
        <Space size={4} breakLine>
          {row.isrNodes?.split(',').map((item, index) => (
            <Tag theme='default' key={index}>
              {item}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <Icon
          type='presentation-chart-line'
          onClick={() => {
            setVisible(true);
            setCurrentRow(row);
          }}
        />
      ),
      width: 60,
    },
  ];

  const loadData = useMemoizedFn(async (params) => {
    const {
      data: { kopTopicPartitionMetricsList },
    } = await getTopicPartitionList({
      ...params,
      clusterName: commonProps.clusterName,
      topic: commonProps.topic,
    });
    setData(kopTopicPartitionMetricsList);
  });

  const { setData, doSearch, config } = useTable({
    columns,
    onSearch: loadData,
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <Root>
      <Table {...config} />
      <BoardModal
        visible={visible}
        detail={currentRow}
        header={
          <ModalHeader
            tags={[commonProps.clusterName, currentRow.topic, `分区：${currentRow.partition}`]}
          >
            监控-Topic
          </ModalHeader>
        }
        getChartsData={(params) =>
          getTopicPartitionChartData({
            clusterName: commonProps.clusterName,
            topicName: commonProps.topic,
            partition: currentRow.partition,
            ...params,
          })
        }
        handleClose={handleClose}
      />
    </Root>
  );
}

const Root = styled.div`
  padding-top: 14px;
`;

const Icon = styled(SvgIcon)`
  cursor: pointer;
  color: #194dff;
`;
